import { Popover, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import QuestionMark from '../../components/img/QuestionMark.svg';

const TrainingsInfo = ({ trainings, purchasedSeats, contractedSeats }) => {
  const [isShowing, setIsShowing] = useState(false);
  return (
    <div className=''>
      <Popover className='relative top-[2px]'>
        {({ open }) => (
          <>
            <Popover.Button
              className={`
                ${open ? '' : 'text-opacity-90'}

                group inline-flex items-center rounded-md  text-base font-medium text-white hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <img
                className='w-4 h-4 ml-1 inline-block align-text-bottom'
                alt='question mark'
                onMouseEnter={() => setIsShowing(true)}
                onMouseLeave={() => setIsShowing(false)}
                src={QuestionMark}
              ></img>
            </Popover.Button>
            <Transition
              show={isShowing}
              onMouseEnter={() => setIsShowing(true)}
              onMouseLeave={() => setIsShowing(false)}
              as={Fragment}
              enter='transition ease-out duration-200'
              enterFrom='opacity-0 translate-y-1'
              enterTo='opacity-100 translate-y-0'
              leave='transition ease-in duration-150'
              leaveFrom='opacity-100 translate-y-0'
              leaveTo='opacity-0 translate-y-1'
            >
              <Popover.Panel className='absolute bottom-[35px] max-lg:-left-3 lg:-right-3 text-left lg:bottom-[35px]  z-10 mt-3 max-w-sm trans transform px-0 sm:px-0 w-[230px] lg:w-screen'>
                <div className='overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5'>
                  <div className=' bg-[#404040] relative'>
                    <a
                      href='##'
                      className='flow-root rounded-md px-2 py-2 transition duration-150 ease-in-out  focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50'
                    >
                      <span className='flex items-center'>
                        <span className='sm:text-sm text-xs font-medium text-white'>
                          {Array.isArray(trainings) ? (
                            (() => {
                              const activeTrainings = trainings.filter(
                                (training) => training.Remaining_Seats__c > 0
                              );

                              if (activeTrainings.length === 0) {
                                return (
                                  <p>
                                    You currently don't have training seats
                                    contracted.
                                  </p>
                                );
                              } else {
                                return (
                                  <div>
                                    <p>You currently have:</p>
                                    <p>
                                      <span className='font-bold text-blue-500 dark:text-white'>
                                        {JSON.stringify(contractedSeats) || 0}
                                      </span>{' '}
                                      seat{contractedSeats !== 1 && 's'}{' '}
                                      available with your partnership, and{' '}
                                      <span className='font-bold text-blue-500 dark:text-white'>
                                        {JSON.stringify(purchasedSeats) || 0}
                                      </span>{' '}
                                      purchased seat
                                      {purchasedSeats !== 1 && 's'}.
                                    </p>
                                    {activeTrainings.map((training) => {
                                      const [year, month, day] =
                                        training.Start_Date__c.split('-');
                                      const formattedDate = `${month}/${day}/${year}`;
                                      return (
                                        <div>
                                          <p key={training.Id}>
                                            {training.Remaining_Seats__c}{' '}
                                            {training.Remaining_Seats__c === 1
                                              ? 'seat'
                                              : 'seats'}{' '}
                                            left to use on courses starting from{' '}
                                            {formattedDate}
                                          </p>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              }
                            })()
                          ) : (
                            <p>-</p>
                          )}
                        </span>
                      </span>
                    </a>
                  </div>
                  <div className='absolute max-lg:left-1 -bottom-2 lg:right-2'>
                    <div className='triangle-analytics'></div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default TrainingsInfo;
